import { Component } from "react";
import React, { ReactNode, ReactNodeArray } from "react";
import { History } from "history";
import { SideMenuPage, Alerta, TipoAlerta } from "@intechprev/componentes-web";
import { Session } from "@intech/react-service";

import { PlanoService, FuncionarioService, LGPDService, FuncionalidadeService, UsuarioService } from "../services";

import Rotas from "../Rotas";
import config from "../config.json";
import { PlanoVinculadoEntidade } from "../entidades";

export enum NumFuncionalidade {
  "HOME_ATIVOS_E_AUTOPATROCINADOS" = 1,
  "HOME_ASISSTIDOS" = 2,
  "SEUS_DADOS" = 3,
  "EXTRATO" = 4,
  "CONTRACHEQUE_ASISSTIDOS_PENSIONISTAS" = 5,
  "EMPRESTIMOS_CONSULTA" = 6,
  "EMPRESTIMOS_SIMULAÇÃO" = 7,
  "EMPRESTIMOS_CONTRATAÇÃO" = 8,
  "INFORME_DE_RENDIMENTOS_ASSISTIDOS_PENSIONISTAS" = 9,
  "INFORME_PLANO_DE_SAÚDE" = 10,
  "FORMULARIOS" = 11,
  "DOCUMENTOS" = 12,
  "FALE_CONOSCO" = 13,
  SIMULADOR_RENDA_MENSAL = 14,
  RECADASTRAMENTO = 16,
  COMPROVANTES = 17,
  DEMONSTRATIVO_EMPRESTIMO = 18,
  DECLARACAO_IR = 19,
  EVENTOS = 36
}

interface Props {
  children?: ReactNode | ReactNodeArray;
  history?: History;
  posicaoEsquerdaCarregando: 0;
  travarScroll?: boolean;
  Funcionalidade?: NumFuncionalidade;
}

interface State {
  admin: boolean;
  carregando: boolean;
  nomeUsuario: string;
  matricula: string;
  motivoBloqueio: string;
}

export class MasterPage extends Component<Props, State> {
  private body = document.querySelector("body");

  static defaultProps = {
    posicaoEsquerdaCarregando: 0,
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      admin: false,
      carregando: false,
      nomeUsuario: "",
      matricula: "",
      motivoBloqueio: "Aguarde enquanto o sistema carrega as informações.",
    };
  }

  componentDidMount = async () => {
    try {
      this.mudarScroll();

      var token = await localStorage.getItem(`@${config.appName}:token`);

      if (token) {
        const admin = await UsuarioService.VerificarAdmin();
        const termo = await LGPDService.Buscar();

        if (termo.length === 0 && !admin) {
          this.props.history.push("/termos");
        } else {
          var dados = await FuncionarioService.Buscar();
          var nomeUsuario = dados.DadosPessoais.NOME_ENTID;
          var matricula = dados.Funcionario.NUM_MATRICULA;

          if (await this.checarPlanoDesligado()) {
            alert(
              "O seu cadastro se encontra na situação de desligado. Por favor entre em contato, ligando para nosso Canal de Atendimento (21 - 2277 1999), que funciona de segunda à sexta-feira, das 9 às 17h."
            );
            this.props.history.push("/login");
          }

          if (dados.Usuario && dados.Usuario.IND_PRIMEIRO_ACESSO === "S") {
            this.props.history.push("/trocarSenhaPrimeiroAcesso");
          } else {
            await this.buscarBloqueio();

            await this.setState({
              nomeUsuario,
              matricula,
              admin,
            });
          }
        }
      } else {
        await this.logout();
      }
    } catch (err) {
      if (err.message.indexOf("401") > -1) {
        await this.logout();
      } else {
        alert("Ops! Ocorreu um erro ao processar sua requisição.");
        console.error(err);
      }
    }
  };

  buscarBloqueio = async () => {
    if (this.props.Funcionalidade) {
      const planos = await PlanoService.Buscar();
      const cdPlanos = [];
      /* Código do plano do participante logado. */
      cdPlanos.push(planos[0].CD_PLANO);
      /* Código do segundo plano do participante logado (repetir o primeiro caso só tenha um plano). */
      cdPlanos.push(planos.length > 1 ? planos[1].CD_PLANO : cdPlanos[0]);
      /* Código do terceiro plano do participante logado (repetir o segundo caso só tenha um ou dois planos ) */
      cdPlanos.push(planos.length > 2 ? planos[2].CD_PLANO : cdPlanos[1]);

      const motivoBloqueio = await FuncionalidadeService.BuscarBloqueiosPorNumFuncionalidade(
        this.props.Funcionalidade,
        cdPlanos[0],
        cdPlanos[1],
        cdPlanos[2]
      );

      this.setState({ motivoBloqueio });
    } else this.setState({ motivoBloqueio: "" });
  };

  checarPlanoDesligado = async () => {
    /*
          Retorna true caso todos os planos vinculados
          ao funcionário em questão estejam na categoria
          "desligado", caso contrário retorna false
        */
    return (await PlanoService.Buscar())
      .map((plano: PlanoVinculadoEntidade) => plano.CD_CATEGORIA === "2")
      .every((planoDesligado: boolean) => planoDesligado === true);
  };

  private mudarScroll = () => {
    if (this.props.travarScroll) {
      if (this.state.carregando) {
        this.travarScroll();
      } else {
        this.liberarScroll();
      }
    }
  };

  private travarScroll = () => {
    this.body.classList.add("modal-open");
  };

  private liberarScroll = () => {
    this.body.classList.remove("modal-open");
  };

  alternarLoading = async () => {
    await this.setState({ carregando: !this.state.carregando });

    this.mudarScroll();
  };

  logout = async () => {
    await Session.clear();
    await this.props.history.push("/login");
  };

  renderCarregando = () => {
    if (this.state.carregando) {
      return (
        <div
          style={{
            opacity: 0.5,
            top: 0,
            left: this.props.posicaoEsquerdaCarregando,
          }}
          className={"loader"}
        >
          <img style={{ width: 300, height: 200 }} src={"./imagens/loading.gif"} alt={"loading"} />
        </div>
      );
    }
    return this.state.motivoBloqueio === "" ? this.props.children : <Alerta mensagem={this.state.motivoBloqueio} tipo={TipoAlerta.danger} />;
  };

  render() {
    return (
      <SideMenuPage
        appName={config.appName}
        logo={"imagens/logo.png"}
        rotas={Rotas}
        admin={this.state.admin}
        // admin={config.admin}
        nomeUsuario={`${this.state.nomeUsuario} (${this.state.matricula})`}
        history={this.props.history}
        {...this.props}
      >
        {this.renderCarregando()}
      </SideMenuPage>
    );
  }
}
